module.exports = __webpack_public_path__ + "static/media/rexoz shot 4-mobile.1268d05c.webp";